import { useEffect, useState } from 'react';
import { makeClassName } from '@siteless/util';

const MOUNT_WAIT = 200;

const Loader = ({ className }: { className?: string }) => {
  let [canRender, setCanRender] = useState(false);

  useEffect(() => {
    let timeout = setTimeout(() => {
      setCanRender(true);
    }, MOUNT_WAIT);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  if (!canRender) return null;

  return (
    <div className={makeClassName('flex h-full w-full items-center justify-center text-neutral-300', className)}>
      <svg width="64" height="64" viewBox="0 0 32 32" fill="currentColor">
        <circle transform="translate(8 0)" cx="0" cy="16" r="0">
          <animate attributeName="r" values="0; 4; 0; 0" dur="1.2s" repeatCount="indefinite" begin="0"
            keyTimes="0;0.2;0.7;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline" />
        </circle>
        <circle transform="translate(16 0)" cx="0" cy="16" r="0">
          <animate attributeName="r" values="0; 4; 0; 0" dur="1.2s" repeatCount="indefinite" begin="0.3"
            keyTimes="0;0.2;0.7;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline" />
        </circle>
        <circle transform="translate(24 0)" cx="0" cy="16" r="0">
          <animate attributeName="r" values="0; 4; 0; 0" dur="1.2s" repeatCount="indefinite" begin="0.6"
            keyTimes="0;0.2;0.7;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline" />
        </circle>
      </svg>
    </div>
  );
};

export default Loader;
